module.exports = __webpack_public_path__ + "static/media/select-arrow.bbe6663e.svg";